import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
    EstablishmentEmptyStateComponent,
} from '../../components/establishment-empty-state/establishment-empty-state.component';
import { RouterOutlet } from '@angular/router';
import { AppContext } from '../../services/app-context.service';

@Component({
    selector: 'app-establishments',
    templateUrl: './establishments.component.html',
    styleUrls: ['./establishments.component.scss'],
    imports: [RouterOutlet, EstablishmentEmptyStateComponent],
})
export class EstablishmentsComponent {

    establishmentId = toSignal(this.appContext.establishmentId$);

    constructor(
        private readonly appContext: AppContext,
    ) {
    }

    // ----------[ Lifecycle Hooks ]----------

}
